/**
 * @fileoverview Numbers theme - match numbers with colored circle borders.
 */

import { ThemeOptions } from '../../services/ThemeService.js';
import { TextCircledMatchingTheme } from '../abstract/TextCircledMatchingTheme.js';

/**
 * Numbers theme (1-9) with circle borders and black text.
 */
export class NumbersTheme extends TextCircledMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super('numbers', 'Numbers', [1, 2, 3, 4, 5, 6, 7, 8, 9], options);
    }
}
